import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BLOB_WIDTH = 350;
const BLOB_HEIGHT = 370;
const BlobWrapper = styled.div.withConfig({
  displayName: "Blob__BlobWrapper",
  componentId: "sc-1hycl9j-0"
})(["position:relative;opacity:1;width:", "px;height:", "px;display:flex;align-items:center;justify-content:center;"], BLOB_WIDTH, BLOB_HEIGHT);
const BackgroundBlob = styled.div.withConfig({
  displayName: "Blob__BackgroundBlob",
  componentId: "sc-1hycl9j-1"
})(["position:absolute;opacity:1;width:", "px;height:", "px;display:flex;align-items:center;justify-content:center;background:", ";border-radius:41% 59% 56% 44% / 33% 39% 61% 67%;z-index:-2;pointer-events:none;will-change:transform,border-radius;"], BLOB_WIDTH, BLOB_HEIGHT, ({
  theme
}) => theme.color['fill-accent-yellow-subtle']);
const BackgroundBlobBright = styled.div.withConfig({
  displayName: "Blob__BackgroundBlobBright",
  componentId: "sc-1hycl9j-2"
})(["position:absolute;opacity:1;width:", "px;height:", "px;display:flex;align-items:center;justify-content:center;background:", ";border-radius:28% 72% 40% 60% / 29% 71% 29% 71%;z-index:-1;pointer-events:none;will-change:transform,border-radius;"], BLOB_WIDTH - 30, BLOB_WIDTH - 30, ({
  theme
}) => theme.color['fill-accent-yellow-hover']);
const Blob = ({
  renderComponent
}) => {
  return /*#__PURE__*/_jsxs(BlobWrapper, {
    children: [/*#__PURE__*/_jsx(BackgroundBlob, {}), /*#__PURE__*/_jsx(BackgroundBlobBright, {}), renderComponent()]
  });
};
export default Blob;